import moment from 'moment';

import { ReportRequestSetData } from '../../typings/reports';
import { ReportClient, ReportClientApiData } from '../../typings/reportsClient';

export function mapReportsApiDataToClientData(
    reports: Array<ReportClientApiData>
): Array<ReportClient> {
    return reports.map((report: ReportClientApiData) => {
        const {
            reportId,
            builtAt,
            dateStart,
            dateEnd,
            reportStatus,
            agencyLogin,
            reportKind
        } = report;
        return {
            id: reportId.toString(),
            buildDate: moment(builtAt),
            dateStart: moment(dateStart),
            dateEnd: moment(dateEnd),
            status: reportStatus,
            agencyLogin,
            reportKind
        };
    });
}

export function mapReportsDatesToApiFormat(
    dates?: ReportRequestSetData
): { dateStart: string; dateEnd: string } {
    if (dates === undefined) {
        return {
            dateStart: moment().format('YYYY-MM-DD'),
            dateEnd: moment().format('YYYY-MM-DD')
        };
    }

    const { dateStart, dateEnd } = dates;
    return {
        dateStart: dateStart.format('YYYY-MM-DD'),
        dateEnd: dateEnd.format('YYYY-MM-DD')
    };
}
